import { Pack, PackFormValues } from "../packs.types";

export const getEditablePackFormValues = (pack: Pack): PackFormValues => {
  return {
    title: pack.title,
    shortId: pack.shortId,
    description: pack.description ?? "",
    media: (() => {
      const sorted = [...(pack.media ?? [])].sort(
        (a, b) => Number(a.priority) - Number(b.priority)
      );
      // legacy fallback: surface old single `image` as the only gallery item
      if (sorted.length === 0 && pack.image) return [pack.image];
      return sorted;
    })(),
    preview: pack.preview ?? null,
    badgeId: pack.badgeId ?? "",
    price: pack.price,
    merchantPrice: pack.merchantPrice || null,
    intermediateResellerPrice: pack.intermediateResellerPrice || null,
    confirmedResellerPrice: pack.confirmedResellerPrice || null,
    influencerPrice: pack.influencerPrice || null,
    recommendedSellingPrice: pack.recommendedSellingPrice || null,
    commission: pack.commission || null,
    commissionPercentage: pack.commissionPercentage || null,
    activeCommissionType: pack.commissionPercentage ? "percentage" : "fixed",
    influencerCommission: pack.influencerCommission || null,
    influencerCommissionPercentage: pack.influencerCommissionPercentage || null,
    activeInfluencerCommissionType: pack.influencerCommissionPercentage
      ? "percentage"
      : "fixed",
    discount: pack.discount || null,
    discountAmount: pack.discountAmount || null,
    activeDiscountType: pack.discountAmount ? "amount" : "percentage",
    allowSellingBelowBuyingPrice: pack.allowSellingBelowBuyingPrice ?? false,
    isActive: pack.isActive,
    isChapshopChoice: pack.isChapshopChoice,
    position: pack.position,
    slots: [...pack.slots]
      .sort((a, b) => a.position - b.position)
      .map((slot) => ({
        id: slot.id,
        title: slot.title,
        position: slot.position,
        options: [...slot.options]
          .sort((a, b) => a.position - b.position)
          .map((option) => ({
            productVariantId: option.productVariantId,
            productVariantName: "",
            productVariantImage: null,
            position: option.position
          }))
      }))
  };
};
